import React from 'react';
import { Link } from 'MWC';
import '../less/main.less';

export default function template() {

  const appleIcon = this.props.isApple ?
    (<Link href='https://bcrw.apple.com/urn:biz:bd844618-a647-47cf-8056-e3a43bfb76c4' target="_blank">
      <div className={`icon-apple ${this.state.isShown ? "active" : ""}`}/>
    </Link>) : '';

  return (
    <div className="scroll-wrap">
      <Link href='https://t.me/abank_bot' target="_blank"><div className={`icon-telegram ${this.state.isShown ? "active" : ""}`}/></Link>
      <Link href='viber://pa?chatURI=abank' target="_blank"><div className={`icon-viber ${this.state.isShown ? "active" : ""}`}/></Link>
      {appleIcon}
      <div
        className={`scroll-faq ${this.state.isShown ? 'active' : ''}`}
        onClick={this.scrollToTop}
      >
        <div className="icon-message"/>
        <div className="icon-close">&times;</div>
      </div>
    </div >
  );
}
